import { Trans, useTranslation } from 'react-i18next';
import { Photo } from 'models/Photos';
import PageHeader from 'components/pageHeader/PageHeader';
import usePropertySettingsInitData from 'pages/property/usePropertySettingsInitData';
import SectionHeader from 'pages/property/common/SectionHeader';
import { useSelectModeContext } from '../../context/SelectModeContext';
import PageTitleDeleteButton from '../selectMode/PageTitleDeleteButton';
import HeaderButtons from './HeaderButtons';

const PropertySettingsPhotosTabHeader = ({
  isLoading,
  photos,
}: {
  isLoading: boolean;
  photos: Photo[];
}) => {
  const { t } = useTranslation();
  const { isSelectMode } = useSelectModeContext();
  const { property } = usePropertySettingsInitData();

  const sectionTitle = `${t('pageProperty.photos.propertyPhotos')}${
    photos?.length > 0 ? ` (${photos.length})` : ''
  }`;

  const title = isSelectMode ? (
    <PageTitleDeleteButton />
  ) : (
    <Trans
      i18nKey="pageProperty.photos.tabTitle"
      values={{ propertyName: property?.name }}
      components={{ 1: <span className="green" /> }}
    />
  );

  return (
    <>
      <PageHeader
        className="tab-title"
        title={title}
        isLoading={isLoading}
        buttons={<HeaderButtons />}
        noDivider
      />

      {!isSelectMode && (
        <SectionHeader
          id="photos-section"
          title={sectionTitle}
          subtitle={t('pageProperty.photos.subtitle')}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default PropertySettingsPhotosTabHeader;
